export const getMobileBrowserSource = () => {
  const ua = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  let deviceType = 'Unknown';
  let browser = 'Unknown';

  // 设备类型检测
  const device = {
    isIOS: /iphone|ipad|ipod/.test(platform),
    isAndroid: /android/.test(ua),
    // isWechat: /micromessenger/.test(ua),
    // isFacebook: /(fban|fbav)/.test(ua),
    // isWebView: /(webview|; wv)/.test(ua)
  };

  // 浏览器特征检测（按优先级排序）
  const browserPatterns = [
    // 厂商浏览器优先检测
    {
      name: 'Huawei',
      pattern: /(huaweibrowser|hbpc)\/([\d.]+)/,
      vendorCheck: /huawei|honor/i
    },
    {
      name: 'Xiaomi',
      pattern: /(miuibrowser|mibrowser|miui)\/([\d.]+)/,
      vendorCheck: /mi\s|redmi|xiaomi/i
    },
    // 应用内浏览器
    // { name: 'WeChat', pattern: /micromessenger\/([\d.]+)/ },
    // { name: 'Facebook', pattern: /(fban|fbav)\/([\d.]+)/ },
    
    // 主流浏览器
    { name: 'Samsung', pattern: /samsungbrowser\/([\d.]+)/ },
    { name: 'Chrome', pattern: /(crios|chrome)\/([\d.]+)/ },
    { name: 'Edge', pattern: /edg(ios|e|a)\/([\d.]+)/ },
    { name: 'Firefox', pattern: /(fxios|firefox)\/([\d.]+)/ },
    { name: 'Safari', pattern: /version\/([\d.]+).+safari/ },
    // { name: 'UC', pattern: /ucbrowser\/([\d.]+)/ },
    // { name: 'Opera', pattern: /opr\/([\d.]+)/ },
    
    // Android系统浏览器
    // { name: 'Android Browser', pattern: /android.+version\/[\d.]+.+mobile safari/ }
  ];
  for (const { name, pattern, vendorCheck } of browserPatterns) {
    const match = ua.match(pattern);
    if (match) {
      if (vendorCheck && !vendorCheck.test(ua)) continue;
      browser = name;
      break;
    }
  }

  // 华为浏览器备用检测（针对新版本UA）
  if (browser === 'Unknown' && /huawei/.test(ua)) {
      const hwMatch = ua.match(/mozilla.*applewebkit.*(hw|huawei)/);
      if (hwMatch) {
          browser = 'Huawei';
      }
  }
  
  if (device.isIOS) {
    deviceType = 'iOS'
  } else if (device.isAndroid) {
    deviceType = 'Android'
  }
  
  return `${deviceType}_${browser}`
}